/* BLENIN cart drawer v2 (2026-10-06). Markup: sections/cart-drawer.liquid, snippets/blenin-cart-ship.liquid,
   snippets/blenin-cart-recs.liquid. Styles: blenin-cart.css.
   1) Title: "Added to your bag" right after an add from a product page or a card (until the next close).
   2) Delivery line + VAT/currency line for the visitor's real country: a country chosen in the selector wins, otherwise
      IP geolocation (/browsing_context_suggestions.json, cached in sessionStorage as bl_geo_v1, shared with the product
      page). Dates use the product-page rule: ships tomorrow..+dispatch days, delivered 3..10 working days later.
   3) "Goes well with": Add (one variant) or size buttons -> /cart/add.js with the header and drawer sections.
   4) Gift note: saved as the cart attribute "Gift note" (shows on the order under Additional details).
   The theme re-renders the drawer after every cart change (on:cart:after-merge); 1) and 2) are re-applied then. */
(function () {
  if (window.blCart2) return;
  window.blCart2 = true;

  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var ICON_OK = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M5 10.4l3 2.9L15 6.5"/></svg>';
  var ICON_TRUCK = '<svg viewBox="0 0 20 20" aria-hidden="true"><rect x="2.5" y="5.5" width="10" height="8" rx="1"/><path d="M12.5 8.5h3l2 2.5v2.5h-5"/><circle cx="6" cy="14.5" r="1.4"/><circle cx="14.5" cy="14.5" r="1.4"/></svg>';
  var ICON_ADDED = '<svg viewBox="0 0 20 20" aria-hidden="true"><circle cx="10" cy="10" r="8.5"/><path d="M6 10.4l2.7 2.6L14.2 7.4"/></svg>';
  var TAX_EU = 'Prices include VAT. Delivery is chosen at checkout.';
  var TAX_OTHER = 'You pay in euros. Your bank converts the amount.';

  function drawer() { return document.querySelector('cart-drawer.js-cart-drawer'); }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }

  /* ---------- money and dates ---------- */
  function money(cents, fmt) {
    var parts = (Math.max(0, cents) / 100).toFixed(2).split('.');
    var dots = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var commas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (fmt || '€{{amount_with_comma_separator}}')
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, dots)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, dots + ',' + parts[1])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, commas)
      .replace(/\{\{\s*amount\s*\}\}/, commas + '.' + parts[1]);
  }
  function addDays(d, n) { var x = new Date(d.getFullYear(), d.getMonth(), d.getDate()); x.setDate(x.getDate() + n); return x; }
  function workDays(d, n) { var x = addDays(d, 0); while (n > 0) { x.setDate(x.getDate() + 1); if (x.getDay() % 6 !== 0) n--; } return x; }
  function one(d) { return d.getDate() + ' ' + MONTHS[d.getMonth()]; }
  function range(a, b) {
    if (a.getTime() === b.getTime()) return one(b);
    return a.getMonth() === b.getMonth() ? a.getDate() + '–' + one(b) : one(a) + ' – ' + one(b);
  }

  /* ---------- country ---------- */
  var geoPromise = null;
  function geo(cb) {
    var K = 'bl_geo_v1', c = null;
    try { c = JSON.parse(sessionStorage.getItem(K) || 'null'); } catch (e) {}
    if (c && c.iso) { cb(c); return; }
    if (!geoPromise) {
      geoPromise = fetch('/browsing_context_suggestions.json', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var d = j && j.detected_values && j.detected_values.country;
          if (!d || !d.handle) return null;
          var v = { iso: String(d.handle).toUpperCase(), name: d.name || '' };
          try { sessionStorage.setItem(K, JSON.stringify(v)); } catch (e) {}
          return v;
        })
        .catch(function () { return null; });
    }
    geoPromise.then(function (v) { if (v && v.iso) cb(v); });
  }

  function thresholdFor(el, iso) {
    var cur = el.dataset.cur || 'EUR', lines = (el.dataset.amounts || '').split(','), fallback = -1;
    for (var i = 0; i < lines.length; i++) {
      var p = lines[i].trim().split(':');
      if (p.length === 3 && p[0] === iso && p[1] === cur) return parseInt(p[2], 10);
      if (p.length === 2 && p[0] === cur) fallback = parseInt(p[1], 10);
    }
    return fallback;
  }

  function renderShip(el, iso, name) {
    var thr = thresholdFor(el, iso);
    var tax = document.querySelector('cart-drawer [data-bl-tax]');
    if (tax) tax.textContent = thr === 1 ? TAX_EU : TAX_OTHER;
    if (thr === -1) { el.hidden = true; return; }
    el.hidden = false;
    var total = parseInt(el.dataset.total, 10) || 0;
    var main = el.querySelector('[data-bl-ship-main]');
    var bar = el.querySelector('[data-bl-ship-bar]');
    var sub = el.querySelector('[data-bl-ship-sub]');
    var where = name || 'your country';
    if (thr > 1 && total < thr) {
      main.innerHTML = ICON_TRUCK + '<span><strong>' + esc(money(thr - total, el.dataset.money)) + '</strong> away from free delivery to ' + esc(where) + '</span>';
      if (bar) { bar.hidden = false; bar.firstElementChild.style.width = Math.max(3, Math.round(total * 100 / thr)) + '%'; }
    } else {
      main.innerHTML = ICON_OK + '<span>' + (thr === 1 ? 'Free delivery to a pickup point' + (name ? ' in ' + esc(name) : '') : 'Free delivery to ' + esc(where)) + '</span>';
      if (bar) bar.hidden = true;
    }
    var disp = parseInt(el.dataset.dispatch, 10);
    if (!(disp >= 1)) disp = 7;
    var now = new Date();
    var shipA = addDays(now, 1), shipB = addDays(now, disp);
    if (sub) sub.textContent = 'Ships within ' + disp + (disp === 1 ? ' day' : ' days') + ' from our warehouse in Europe. Estimated delivery ' + range(workDays(shipA, 3), workDays(shipB, 10)) + '.';
  }

  function updateShip() {
    var el = document.querySelector('cart-drawer [data-bl-ship]');
    if (!el) return;
    var iso = (el.dataset.iso || '').toUpperCase();
    var def = (el.dataset.defaultIso || '').toUpperCase();
    if (iso && iso !== def) { renderShip(el, iso, el.dataset.name || ''); return; }
    renderShip(el, iso, '');
    geo(function (g) {
      var cur = document.querySelector('cart-drawer [data-bl-ship]');
      if (cur) renderShip(cur, g.iso, g.name || g.iso);
    });
  }

  /* ---------- "Added to your bag" ---------- */
  var addedAt = 0;
  function markAdded() {
    var t = document.querySelector('cart-drawer #CartDrawerModal-Title');
    if (!t) return;
    var showing = !!t.querySelector('[data-bl-added]');
    var on = addedAt && Date.now() - addedAt < 8000;
    if (on && !showing) {
      t.dataset.blOrig = t.innerHTML;
      t.innerHTML = ICON_ADDED + '<span data-bl-added>Added to your bag</span>';
      t.classList.add('bl-added');
    } else if (!on && showing) {
      // Reopened later without a cart change: back to "Your bag (n)".
      if (t.dataset.blOrig) t.innerHTML = t.dataset.blOrig;
      t.classList.remove('bl-added');
    } else if (!on) {
      t.classList.remove('bl-added');
    }
  }
  document.addEventListener('on:cart:add', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('cart-drawer')) return;
    addedAt = Date.now();
    setTimeout(markAdded, 0);
    setTimeout(markAdded, 400);
  });
  document.addEventListener('on:cart-drawer:after-close', function () { addedAt = 0; });

  /* ---------- Goes well with ---------- */
  function sectionEls() {
    return ['page-header', 'cart-drawer'].map(function (s) { return document.querySelector(s); })
      .filter(function (el) { return el && el.dataset && el.dataset.sectionId; });
  }
  function say(card, text, isError) {
    var m = card.querySelector('.bl-rec__msg');
    if (!m) return;
    m.textContent = text;
    m.classList.toggle('is-error', !!isError);
  }
  function addVariant(card, id) {
    if (card.classList.contains('is-loading')) return;
    card.classList.add('is-loading');
    say(card, '');
    var els = sectionEls();
    var fd = new FormData();
    fd.append('id', id);
    fd.append('quantity', '1');
    fd.append('sections_url', window.location.pathname);
    fd.append('sections', els.map(function (el) { return el.dataset.sectionId; }).join(','));
    var url = (window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js';
    fetch(url, { method: 'POST', headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        var d = res.data || {};
        if (!res.ok || d.status) throw new Error(typeof d.description === 'string' ? d.description : (d.message || 'Could not add to bag. Please try again.'));
        els.forEach(function (el) {
          if (d.sections && d.sections[el.dataset.sectionId] && typeof el.updateFromCartChange === 'function') el.updateFromCartChange(d.sections[el.dataset.sectionId]);
        });
        card.classList.remove('is-loading');
      })
      .catch(function (err) { card.classList.remove('is-loading'); say(card, err.message, true); });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-bl-rec-add], [data-bl-rec-size]');
    if (!t) return;
    var card = t.closest('[data-bl-rec]');
    if (!card) return;
    e.preventDefault();
    if (t.hasAttribute('data-bl-rec-size')) { addVariant(card, t.dataset.id); return; }
    if (card.dataset.singleId) { addVariant(card, card.dataset.singleId); return; }
    var row = card.querySelector('.bl-rec__sizes');
    if (!row) return;
    var open = row.hidden;
    row.hidden = !open;
    t.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (!open) return;
    var sel = row.querySelector('[data-bl-rec-select]');
    var first = row.querySelector('[data-bl-rec-size]');
    if (!first && !(sel && sel.options.length > 1)) { say(card, 'Sold out in this colour.', true); return; }
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    try { row.scrollIntoView({ block: 'nearest', behavior: still ? 'auto' : 'smooth' }); } catch (err) {}
    if (sel) { sel.focus({ preventScroll: true }); try { if (sel.showPicker) sel.showPicker(); } catch (err) {} }
    else first.focus({ preventScroll: true });
  });
  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (!sel || !sel.matches || !sel.matches('[data-bl-rec-select]') || !sel.value) return;
    var card = sel.closest('[data-bl-rec]');
    if (card) addVariant(card, sel.value);
  });

  /* ---------- Gift note ---------- */
  var giftTimer = null;
  function giftStatus(text) { var s = document.querySelector('[data-bl-gift-status]'); if (s) s.textContent = text; }
  function saveGift(value) {
    var url = (window.theme && theme.routes && theme.routes.cartUpdate) || '/cart/update.js';
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { 'Gift note': value } })
    }).then(function (r) { giftStatus(r.ok ? (value ? 'Saved' : '') : 'Not saved. Please try again.'); })
      .catch(function () { giftStatus('Not saved. Please try again.'); });
  }
  document.addEventListener('change', function (e) {
    if (!e.target || e.target.id !== 'bl-gift-toggle') return;
    var body = document.querySelector('[data-bl-gift-body]');
    var ta = document.getElementById('bl-gift-text');
    if (body) body.hidden = !e.target.checked;
    if (e.target.checked) { if (ta) ta.focus(); return; }
    clearTimeout(giftTimer);
    if (ta && ta.value.trim()) { ta.value = ''; saveGift(''); }
  });
  document.addEventListener('input', function (e) {
    if (!e.target || e.target.id !== 'bl-gift-text') return;
    var value = e.target.value.trim();
    giftStatus('Saving…');
    clearTimeout(giftTimer);
    giftTimer = setTimeout(function () { saveGift(value); }, 700);
  });

  /* ---------- wiring ---------- */
  function refresh() { updateShip(); markAdded(); }
  document.addEventListener('on:cart:after-merge', refresh);
  document.addEventListener('on:cart-drawer:before-open', refresh);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh);
  else refresh();
})();
